import React, { useState, useContext } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { Row, Col } from "../../../components/layout";
import { OutlineButton } from "../../../components/buttons";
import { SvgIconContainer } from "../../../components/icons";
import { draftStore } from "../../../store";
import { setRoundFilter } from "../../../actions/status";
import {
  FcRank,
  PlayerLastName,
  PlayerFirstName,
} from "../../../components/text";
import { mobileBreakpoint } from "../../../lib";
import { PlayerLink } from "../../../components";

const SummaryRow = styled(Row)`
  position: relative;
`;

const Heading = styled.h3`
  margin: 0;
  padding: 0;
`;

const PlayerCardContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: #161718;
  min-height: 83px;
  margin-top: 5px;
  position: relative;
`;

const TeamLogo = styled.img.attrs((props) => ({
  src: props.src,
}))`
  width: 100%;
  height: 100%;
  max-width: 44px;
  height: 44px;
`;

const PickNumber = styled.span`
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
`;

const PlayerInfo = styled.span`
  font-size: 12px;
  line-height: 18px;
  padding-right: 10px;
`;

const PlayerListContainer = styled(Row)`
  max-height: 1500px;
  overflow-y: overlay;
  overflow-x: hidden;
`;

function getFilteredPlayers(players, roundFilter, showPlayersFilter) {
  const filteredPlayers = players
    .filter((player) => player.roundPicked === roundFilter)
    .filter((player) =>
      showPlayersFilter === "MINE" ? player.pickedBy.isUserTeam : true
    );
  return [...filteredPlayers].reverse();
}

export const PlayerCard = ({ player, rankingTitle }) => (
  <PlayerCardContainer key={player.id}>
    <SvgIconContainer show={player.pickedBy.isUserTeam}>
      <svg width="31px" height="31px" viewBox="0 0 31 31" version="1.1">
        <path
          d="M0 0L31 0L0 31L0 0Z"
          id="Rectangle"
          fill="#D6001C"
          stroke="none"
        />
        <path
          d="M0 3.09627L2.60266 6L8 0"
          transform="translate(6 6)"
          id="Path-2"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
        />
      </svg>
    </SvgIconContainer>
    <Col size="12%" justifyContent="center" alignItems="center">
      <PickNumber>{player.numberPicked}</PickNumber>
    </Col>
    <Col size="12%" justifyContent="center" alignItems="center">
      <TeamLogo src={player.pickedBy.logo} />
    </Col>
    <Col size="4%"></Col>
    <Col size="71%" justifyContent="center" flexDirection="column">
      <SummaryRow margin="0 0 4px 0" alignItems="flex-end">
        <PlayerLastName>{player.lastName}</PlayerLastName>
        <PlayerFirstName>{player.firstName}</PlayerFirstName>
        <PlayerLink player={player} />
      </SummaryRow>
      <Row margin="0 0 5px 0">
        <PlayerInfo>
          <span style={{ marginRight: "3px" }}>
            {player.position}, {player.team}, {player.league}
          </span>
        </PlayerInfo>
      </Row>
      <Row>
        <FcRank>
          {rankingTitle} {player.fcRank}
        </FcRank>
      </Row>
    </Col>
  </PlayerCardContainer>
);

function DraftSummary({ selectedPlayers }) {
  const { state, dispatch } = useContext(draftStore);
  const [filterPicksValue, setPicksFilter] = useState("ALL");
  const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });

  // const { options: {totalRounds}, status: { currentPickNumber, roundFilter }, teams: { data: teams } } = state;
  const {
    options: { totalRounds, rankingTitle },
    status: { roundFilter },
  } = state;

  // const currentRound = Math.ceil(currentPickNumber/ teams.length);
  const filteredPlayers = getFilteredPlayers(
    selectedPlayers,
    roundFilter,
    filterPicksValue
  );

  return (
    <>
      <Row margin="18px 0 41px 0" justifyContent="space-between">
        {!isMobile && (
          <Col>
            <Heading>Draft Summary</Heading>
          </Col>
        )}
        <Col>
          <OutlineButton
            margin="0 10px 0 0"
            selected={filterPicksValue === "ALL"}
            onClick={() => setPicksFilter("ALL")}
          >
            All Picks
          </OutlineButton>
          <OutlineButton
            selected={filterPicksValue === "MINE"}
            onClick={() => setPicksFilter("MINE")}
          >
            My Picks
          </OutlineButton>
        </Col>
      </Row>
      <Row>
        {Array(totalRounds)
          .fill()
          .map((val, id) => (
            <OutlineButton
              margin="0 10px 0 0"
              key={id}
              onClick={() => dispatch(setRoundFilter(id + 1))}
              selected={id + 1 === roundFilter}
            >
              Rnd {id + 1}
            </OutlineButton>
          ))}
      </Row>
      <PlayerListContainer>
        {filteredPlayers.map((player, idx) => (
          <PlayerCard
            key={player.id}
            player={player}
            rankingTitle={rankingTitle}
          />
        ))}
      </PlayerListContainer>
    </>
  );
}

export default DraftSummary;
